
import { defineComponent, getCurrentInstance, onMounted, PropType } from "vue";
import { Toast } from "bootstrap";

import { Alert } from "@/utils/alertQueue";

const BsFixedColor = {
  info: "#0dcaf0",
  success: "#198754",
  warning: "#ffc107",
  danger: "#dc3545",
}

export default defineComponent({
  props: {
    alert: Object as PropType<Alert>,
    delay: {
      type: Number,
      default: 5000,
    },
  },
  setup() {
    const vm = getCurrentInstance();

    onMounted(() => {
      const el = vm?.refs["toast"] as Element;
      const toast = Toast.getOrCreateInstance(el);
      toast.show();
      el.addEventListener('hidden.bs.toast', () => {
        toast.dispose();
      });
    });

    return {
      BsFixedColor,
    };
  }
});
